import React, { ReactNode } from 'react'
import parse from 'autosuggest-highlight/parse'
import match from 'autosuggest-highlight/match'

/**
 * Highlights the search term in the given text.
 * @param text The text to be highlighted.
 * @param searchTerm The term to highlight within the text.
 * @param transformPart Optional transformation function for each highlighted part.
 */
export const highlightSearchTerm = (
  text: string,
  searchTerm: string,
  transformPart?: (part: string, index: number) => ReactNode
): ReactNode => {
  const matches = match(text, searchTerm, { insideWords: true })
  const parts = parse(text, matches)

  return (
    <span>
      {parts.map((part, index) => (
        <span
          key={index}
          style={{
            fontWeight: part.highlight ? 700 : 400
          }}
        >
          {transformPart ? transformPart(part.text, index) : part.text}
        </span>
      ))}
    </span>
  )
}
